import { render, staticRenderFns } from "./c-pattern-operator-chip.vue?vue&type=template&id=90e0c9f2&scoped=true&"
var script = {}
import style0 from "./c-pattern-operator-chip.vue?vue&type=style&index=0&id=90e0c9f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e0c9f2",
  null
  
)

export default component.exports